import React, { Suspense, useEffect, useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import { createResourcesFormData } from "./data/CreateResourcesForm.data";
import Buttons from "../../components/ui/button/Buttons";
import { Accordion } from "react-bootstrap";
import { useLazyGetSignUpDropDownsForCorporateMembersQuery, useStoreBase64ImageMutation } from "../../app/services/common/commonApi";
import SwalAlert from "../../services/swalService/SwalService";
import { setAllDropDownField } from "./Utils/dropDown";
import DataLoader from "../../components/ui/dataLoader/DataLoader";
import { useAddCorporateResourcesMutation, useDownloadAllTypesDocForResourceMutation, useUploadPdfForResourcesMutation } from "../../app/services/Resource/resourceApi";
import moment from "moment";
import { decryptAES } from "../../services/CryptoService";
import ToastService from "../../services/toastService/ToastService";

const CreateResource = () => {
  const formRef = useRef();
  const { error, success } = SwalAlert();
  const [formData, setFormData] = useState(createResourcesFormData);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadPdfForResources, { isSuccess: isSuccessUpload, isLoading: isLoadingUpload, data: documentUploadData }] = useUploadPdfForResourcesMutation();
  const [signUpDropDownsForCorporateMembers, { data: signUpDropDownsData, isLoading: signUpDropDownsLoading, isFetching: signUpDropDownsFetching, isError: signUpDropDownsIsError, error: signUpDropDownsError, }] = useLazyGetSignUpDropDownsForCorporateMembersQuery();
  const [addCorporateResources, { isSuccess: isSuccessAddResources, isLoading: isLoadingAddResources, data: addResourcesData }] = useAddCorporateResourcesMutation();
  const [downloadResourceDoc, { isSuccess: isDownloadSuccess, },] = useDownloadAllTypesDocForResourceMutation();
  
  const handleSave = () => {
    const formData = formRef.current.getFormData();
    if (!formData) {
      error("Please fill in all mandatory fields to continue.", "")
      return;
    }
    let req = {
      categoryTypeId: formData?.category?.value || null,
      membershipTypeId: formData?.membershipType.join(",") || null,
      documentName: formData?.document || "",
      uploadFileName: uploadedFile?.fileName || "",
      UploadFilePath: uploadedFile?.filePath || "",
      publishDate: formData?.publishDate || null,
      publishTime: moment(formData?.publishTime).format("HH:mm:ss") || null,
      removalDate: formData?.removalDate != null ? formData?.removalDate : null,
      removalTime: formData?.removalTime != null ? moment(formData?.removalTime).format("HH:mm:ss") : null,
      resourceId: null
    }
    addCorporateResources(req)
  };

  const handleDwonloadFile = async () => {
    try {
      const fileExt = uploadedFile?.filePath?.match(/\.[^.]+$/)?.[0];
      const req = {
        type: fileExt,
        Path: uploadedFile?.filePath,
      };
      const blob = await downloadResourceDoc(req).unwrap();
      // Download file
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      // link.download = `resource${fileExt || ".zip"}`;
      link.download = `${uploadedFile?.fileName?.replace(/_[^.]+(?=\.)/, "")}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      ToastService.error("File not found")
    }
  }


  const handleOrganazationImageUpload = async (dataField, newFileObject, e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("File", file); // MUST be "File"
    formData.append("StoragePath", "UploadResourceDocument");

    try {
      const response = await uploadPdfForResources(formData).unwrap();
      let file = decryptAES(response.responseData)
      setUploadedFile(file);
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  const handleClearClick = () => {
    let form = { ...formData };
    form.initialState = { ...form.initialState };
    const updatedInitialState = {
      ...form.initialState,
      fileUpload: "",
    }
    setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
  }

  const handleFormFieldChange = (dataField, value, updatedData, e) => {
    let form = { ...formData };
    form.initialState = { ...form.initialState };
    if (dataField === "uploadButton" && value) {
      handleOrganazationImageUpload(dataField, value, e);
      const updatedInitialState = {
        ...form.initialState,
        fileUpload: value?.fileName ? value?.fileName : value?.name,
      }
      setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
    } else if (dataField === "publishDate") {
      const updateForm = { ...form, initialState: { ...form.initialState, publishDate: new Date(value), }, formFields: form.formFields.map(field => field.id === "removalDate" ? { ...field, fieldSetting: { ...field.fieldSetting, minDate: new Date(value), }, } : field), };
      setFormData(prev => ({ ...prev, ...updateForm, initialState: { ...prev.initialState, ...updateForm.initialState, }, }));
    }
    else if (dataField === "publishTime") {
      let newTime = new Date(value);
      let minTime = new Date();
      minTime.setHours(newTime.getHours(),newTime.getMinutes(),newTime.getSeconds(),0);
      const updateForm = {
        ...form, initialState: { ...form.initialState, publishTime: new Date(value), }, formFields: form.formFields.map(field => field.id === "removalTime" ? {
          ...field, fieldSetting: {...field.fieldSetting, minTime: minTime,},} : field),};
      setFormData(prev => ({ ...prev, ...updateForm, initialState: { ...prev.initialState, ...updateForm.initialState, }, }));
    }
    else {
      setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...form.initialState, [dataField]: value, }, }));
    }
  }

  const handleBack = () => {
    window.history.back();
  };

  useEffect(() => {
    if (!isLoadingAddResources && addResourcesData) {
      if (addResourcesData?.keyId > 0) {
        success("Resource created successfully.")
        handleBack()
      }
    }
  }, [isLoadingAddResources, addResourcesData]);

  useEffect(() => {
    signUpDropDownsForCorporateMembers()
  }, [])

  useEffect(() => {
    if (!signUpDropDownsLoading && signUpDropDownsData) {
      setAllDropDownField(signUpDropDownsData);
    }
  }, [signUpDropDownsLoading, signUpDropDownsData]);

  const formActionHandler = {
    DOWNLOAD: handleDwonloadFile,
    CLEAR: handleClearClick
  }

  return (
    <div className="create-resources container-fluid">
      <div className="resources-form normal-card p-4 bg-white  rounded">
        {signUpDropDownsData && <Accordion>
          <div className="row">
            <Suspense fallback={<DataLoader />}>
              <FormCreator
                ref={formRef}
                {...formData}
                onFormFieldValueChange={handleFormFieldChange}
                onActionChange={formActionHandler}
              />
            </Suspense>
          </div>
          <div className="d-flex justify-content-between ">
            <Buttons
              buttonText="Back"
              buttonTypeClassName="black-btn"
              onClick={handleBack}
            />
            <Buttons
              buttonText="Save"
              buttonTypeClassName="success-btn"
              onClick={handleSave}
              isLoading={isLoadingAddResources}
              isDisable={isLoadingAddResources}
            />
          </div>
        </Accordion>}
      </div>
    </div>
  );
};

export default CreateResource;
